export enum RequesterTypeEnum {
  DEPARTMENT = 'DEPARTMENT',
  STORE = 'STORE'
}

export enum RequesterTypeString {
  DEPARTMENT = 'Department',
  STORE = 'Store'
}
